import { useEffect } from "react";
import { CompaniesColumns, useCompaniesColumns } from "./columns";
import DataTableCompanies from "./data-table";
import { useSelector } from "react-redux";
import { useAppDispatch } from "@/redux/hooks";

import { getDataCompanies } from "@/redux/clients/clients.action";
import { clientSelector } from "@/redux/clients/clients.selector";
import { TableSkeleton } from "@/components/ui/loading";

const CompaniesTable = () => {
  const dispatch = useAppDispatch();
  const { companiesTable, loading } = useSelector(clientSelector).ui;
  const columnsCompanies = useCompaniesColumns();
  useEffect(() => {
    dispatch(getDataCompanies());
  }, [dispatch]);

  const dataCompanies =
    (companiesTable &&
      companiesTable.map((company) => ({
        clienteId: company.clienteid,
        numeroCliente: company.numerocliente,
        clienteNombre: company.clientenombre,
        quantityCarpetas: company.quantitycarpetas,
        canales: company.canales,
      }))) ||
    [];

  return (
    <div className="container pb-2 min-w-full">
      {loading ? (
        <TableSkeleton rows={8} columns={5} />
      ) : (
        <DataTableCompanies
          columns={columnsCompanies}
          data={dataCompanies as CompaniesColumns[]}
        />
      )}
    </div>
  );
};

export default CompaniesTable;
